exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".textarea {\n  padding: 10px;\n  width: calc(100% - 24px);\n  height: 200px;\n  border: 2px solid #aaa;\n  background-color: transparent;\n  color: #fffed8;\n  font-weight: 700;\n  font-size: 34px;\n  resize: none; }\n  .textarea:invalid {\n    box-shadow: none; }\n  .textarea:focus {\n    outline: 0; }\n  .textarea::placeholder {\n    color: #222; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/layout/Textarea/index.scss
// module id = 1102
// module chunks = 0